import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { getTmdbImage } from "../../../utils/consts";

type TmdbImageProps = {
    src: string;
    size?: string;
    alt?: string;
    className?: string;
    style?: React.CSSProperties;
    isSpoiler?: boolean;
}

function TmdbImage({src, size, alt, className, style, isSpoiler}: TmdbImageProps) {

    const [imageBlobUrl, setImageBlobUrl] =  useState(null);
    const imgRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        let blobUrl = null;
        setImageBlobUrl(getTmdbImage(src, size ?? "original"));
        const timeoutId = setTimeout(() => {
            if (!blobUrl) {
                setImageBlobUrl(`https://image.tmdb.org/t/p/${size ?? "original"}${src}`);
            }
        }, 2300);
        
        fetch(getTmdbImage(src, size ?? "original"))
            .then(response => {
                if (!response.ok) {
                    return null;
                }
                return response.blob();
            })
            .then(blob => {
                if (blobUrl || !blob) {
                    return;
                }
                const url = URL.createObjectURL(blob);
                blobUrl = url;
                setImageBlobUrl(url);
                clearTimeout(timeoutId);
            });
        
        return () => {
            clearTimeout(timeoutId);
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };

    }, [size, src]);

    useLayoutEffect(() => {
        if (imgRef.current && isSpoiler) {
            imgRef.current.style.filter = `blur(${(imgRef.current.offsetWidth ?? 1000) * 0.05}px)`;
        }
    }, [isSpoiler, imgRef.current]);

    return (
        <img ref={imgRef} src={imageBlobUrl} alt={alt} className={className} style={{
            filter: isSpoiler ? "blur(100vw)" : "none",
            ...style
        }}/>
    )
}

export default TmdbImage;